// src/consent/ConsentBanner.jsx
import { useEffect, useState } from "react";

const LS_KEY = "consent_ok"; // doar ca să nu mai afișăm bannerul data viitoare

export default function ConsentBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(LS_KEY);
      if (!saved) setOpen(true);
    } catch {
      setOpen(true); // dacă localStorage e blocat, arătăm bannerul o singură dată
    }
  }, []);

  if (!open) return null;

  const onOk = () => {
    try {
      localStorage.setItem(LS_KEY, "1");
    } catch {}
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] px-4 pb-3">
      <div className="mx-auto max-w-3xl rounded-xl border border-black/10 bg-white/95 backdrop-blur px-4 py-3 shadow-lg">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-gray-800">
            Nu colectăm și nu stocăm date personale. Nu folosim cookie-uri de analiză sau publicitate.
          </p>
          <button
            onClick={onOk}
            className="self-end sm:self-auto rounded-full px-4 py-2 bg-manupro-primary text-white font-medium hover:brightness-110 ring-1 ring-manupro-ring/60 transition"
            aria-label="OK"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
